export default "__VITE_ASSET__CCcE_Su3__"